import type { Dayjs } from 'dayjs'
import type { PropsWithChildren } from 'react'

import { getTranslate } from '@/legacy-src/utilities/i18n'

import { formatWeekdayDate } from '@/src/utils/formatLocalizedDate'

import { Heading } from '@/src/domains/design-system/components/Heading'
import { Text } from '@/src/domains/design-system/components/Text'

export interface ClientBookingDaySlotsProps extends PropsWithChildren {
  day: Dayjs
  duration: number
}

export const ClientBookingDaySlots = ({ day, duration, children }: ClientBookingDaySlotsProps) => {
  const { t } = getTranslate()

  return (
    <section className="flex flex-col gap-3">
      <div className="flex items-baseline justify-between">
        <div className="flex flex-col gap-4">
          <Heading element="h2" variant="xl">
            {t('component.calendar.availableSlots')}
          </Heading>
          <Text element="p">{formatWeekdayDate(day)}</Text>
        </div>
        <Text element="p">{t('general.appointments.duration', { duration })}</Text>
      </div>
      {children}
    </section>
  )
}
